"use client";
import { LayoutWrapper as StyledLayoutWrapper } from "./style";

export function LayoutWrapper({ children }: { children: React.ReactNode }) {
  return <StyledLayoutWrapper id="root-layout">{children}</StyledLayoutWrapper>;
}
